import HomeLayout from '@/app/home/views/components/HomeLayout.vue'
export default [
  {
    path: '/enroll',
    component: HomeLayout,
    children: [
      // 查询页
      {
        path: 'list',
        component: () => import('@/app/enroll/index'),
        name: 'enrollList',
        meta: { title: 'module.enroll.098661-0', icon: 'guide', whiteList:true}
      },
      // 详情页
      {
        path: 'details',
        component: () => import('@/app/enroll/details'),
        name: 'enrollDetails',
        meta: { title: 'module.enroll.098661-1', icon: 'guide', whiteList: true, isSupplierCodeRequired: true}
      },
      // 门户-寻源-询价单
      {
        path: 'doorSourcing',
        component: () => import('@/app/enroll/doorSourcing'),
        name: 'doorSourcingDetails',
        meta: { title: 'module.enroll.098661-2', icon: 'guide', whiteList: true, isSupplierCodeRequired: true}
      },
      // 门户-寻源-招标单
      {
        path: 'bidSourcing',
        component: () => import('@/app/enroll/bidSourcing'),
        name: 'bidSourcingDetails',
        meta: { title: 'module.enroll.098661-2', icon: 'guide', whiteList: true, isSupplierCodeRequired: true}
      }
    ]
  }

]

